import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Tabs from '@cloudscape-design/components/tabs';
import Box from '@cloudscape-design/components/box';
import { SearchForm } from './SearchForm';

type SearchTab = 'paymentId' | 'fileName' | 'execution' | 'batchIndex';

interface TabConfig {
  id: SearchTab;
  label: string;
  placeholder: string;
  bulkPlaceholder: string;
}

const tabConfigs: TabConfig[] = [
  {
    id: 'paymentId',
    label: 'Payment ID',
    placeholder: 'Enter End-to-End ID, e.g. DASAVFAR7Y9W2DC',
    bulkPlaceholder: 'Enter multiple Payment IDs, one per line',
  },
  {
    id: 'fileName',
    label: 'File Name',
    placeholder: 'Enter file name, e.g. pain.001.001.03_2025-06-01.xml',
    bulkPlaceholder: 'Enter multiple file names, one per line',
  },
  {
    id: 'execution',
    label: 'Execution Name',
    placeholder: 'Enter execution name',
    bulkPlaceholder: 'Enter multiple execution names, one per line',
  },
  {
    id: 'batchIndex',
    label: 'Batch Index',
    placeholder: 'Enter batch index identifier',
    bulkPlaceholder: 'Enter multiple batch indexes, one per line',
  },
];

export const SearchTabs = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<SearchTab>('paymentId');
  const [bulkMode, setBulkMode] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const activeConfig = tabConfigs.find(t => t.id === activeTab)!;

  const handleSearch = () => {
    const trimmed = searchValue.trim();
    if (!trimmed) return;

    if (activeTab === 'paymentId' && !bulkMode) {
      navigate(`/payment?id=${encodeURIComponent(trimmed)}`);
    } else if (activeTab === 'fileName' && !bulkMode) {
      navigate(`/file?name=${encodeURIComponent(trimmed)}`);
    } else {
      console.log(`Searching by ${activeTab}:`, trimmed, { bulkMode });
    }
  };

  return (
    <Tabs
      activeTabId={activeTab}
      onChange={({ detail }) => {
        setActiveTab(detail.activeTabId as SearchTab);
        setSearchValue('');
      }}
      tabs={tabConfigs.map(config => ({
        id: config.id,
        label: config.label,
        content: (
          <Box padding={{ top: 'm' }}>
            <SearchForm
              placeholder={config.placeholder}
              bulkPlaceholder={config.bulkPlaceholder}
              bulkMode={bulkMode}
              onBulkModeChange={setBulkMode}
              searchValue={searchValue}
              onSearchValueChange={setSearchValue}
              onSearch={handleSearch}
            />
          </Box>
        ),
      }))}
    />
  );
};
